const projectData = [
  {
    id: 1,
    imageChoice: "img/liberia1.png",
    textPosition: "left",
    headerText: "The WASH Project",
    pText:
      "Girls are the breadwinners in impoverish communities, walking away from home to fetch water envision builds boreholes and hand pumps to provide clean and safe drinking water enabling woman and girls to have clean water close to their homes.",
  },
  {
    id: 2,
    imageChoice: "img/liberia2.png",
    textPosition: "right",
    headerText: "Mother and Child Health Project",
    pText:
      "It focuses on raising awareness and promoting various health initiatives pertaining to Maternal and Child Health in Greater Monrovia's slum communities.",
  },
  {
    id: 3,
    imageChoice: "img/liberia3.png",
    textPosition: "left",
    headerText: "Meeting at Ministry of Health",
    pText: `EHAI was welcomed as a partner by the Ministry of Health during a meeting. They introduced themselves, presented their profile, and discussed collaboration with other partners. They also met with the Montserrado County Health Team to discuss the implementation of their project "Healthy Mama, Happy Baby".`,
  },
  {
    id: 4,
    imageChoice: "img/tanzania1.png",
    textPosition: "left",
    headerText: "Empowering Young People for Social Change",
    pText:
      "EHAI collaborated with Tanzania Youth Espouse for Gender and Development (TYEGD). A youth non-governmental and non-profit organization evolved from a collective critical reflection on gender relations, human rights, and the role of young people in bringing about social change in the community via their collective efforts.",
  },
  {
    id: 5,
    imageChoice: "img/malawi1.png",
    textPosition: "left",
    headerText: "Community Engagement for Health Equity",
    pText:
      "We work with Community Engagement for Health Equity (CEHE) as our implementing partner on Maternal and Infant Health, Water Hygiene and Sanitation (WASH), HIV/AIDS, and Economic empowerment programs",
  },
  {
    id: 6,
    imageChoice: "img/usa1.png",
    textPosition: "left",
    headerText: "United States Project",
    pText:
      "Our U.S.-based program focuses on Rural Health Issues, including Maternal and Child Health, Teenage Pregnancy Prevention through health education and promotion, and HIV/AIDS.",
  },
];

export default projectData;
